{
  "app": {
    "brand": "Album Poster Generator",
    "headline": "Make a print-ready album poster.",
    "description": "Search an album, choose a model, tweak the poster, and export a PNG."
  },
  "search": {
    "title": "Find album data",
    "artist": "Artist",
    "artistPlaceholder": "Kanye West",
    "title": "Title",
    "titlePlaceholder": "Kids See Ghosts",
    "year": "Year",
    "yearPlaceholder": "2018",
    "type": "Type",
    "any": "Any",
    "album": "Album",
    "ep": "EP",
    "single": "Single",
    "other": "Other",
    "search": "Search",
    "searching": "Searching…",
    "clear": "Clear",
    "startManually": "Start manually",
    "recent": "Recent",
    "resultsFound": "{count} result found. | {count} results found.",
    "noResults": "No results found. Adjust the query or fill in details manually.",
    "unknownArtist": "Unknown artist",
    "unknownDate": "Unknown date",
    "noArt": "No art"
  },
  "models": {
    "back": "Back to search",
    "title": "Choose a poster model",
    "subtitle": "Select a starting point. You can still edit every field after this.",
    "cleanLabel": "Clean",
    "cleanDesc": "Balanced, modern poster. Artwork, tracklist, palette — everything in its place.",
    "atmosphereLabel": "Atmosphere",
    "atmosphereDesc": "Artwork fills the background behind generous spacing and elegant serif type."
  },
  "editor": {
    "previewTitle": "Preview",
    "previewCaption": "Only the poster surface is captured during PNG export.",
    "back": "Back",
    "tabInformation": "Information",
    "tabTracklist": "Tracklist",
    "tabStyle": "Style",
    "albumDetails": "Album details",
    "title": "Title",
    "artist": "Artist",
    "releaseDate": "Release date",
    "releaseDateAria": "Release date, for example 2018-06-08",
    "metadataLine": "Metadata line",
    "artwork": "Artwork",
    "artworkUrl": "Artwork URL",
    "uploadArtwork": "Upload artwork",
    "tracklist": "Tracklist",
    "showOnPoster": "Show on poster",
    "oneTrackPerLine": "One track per line",
    "tracklistHint": "One track per line. Numbers are added on the poster.",
    "tracklistColumns": "Tracklist columns",
    "column1": "1 column",
    "column2": "2 columns",
    "column3": "3 columns",
    "tracklistSize": "Tracklist size",
    "small": "Small",
    "medium": "Medium",
    "large": "Large",
    "typography": "Typography",
    "font": "Font",
    "selectFont": "Select font",
    "color": "Color",
    "weight": "Weight",
    "size": "Size",
    "italic": "Italic",
    "uppercase": "Uppercase",
    "sectionTitle": "Title",
    "sectionArtist": "Artist",
    "sectionMetadata": "Date / metadata",
    "sectionTracklist": "Tracklist",
    "weightRegular": "Regular",
    "weightMedium": "Medium",
    "weightBold": "Bold",
    "weightExtraBold": "Extra bold",
    "weightBlack": "Black",
    "swatches": "Swatches",
    "paletteSwatches": "Palette swatches",
    "swatchShape": "Swatch shape",
    "shapeSquare": "Square",
    "shapeCircle": "Circle",
    "swatch": "Swatch {n}",
    "background": "Background",
    "backgroundMode": "Mode",
    "modeDefault": "Default",
    "modeSolid": "Solid",
    "modeGradient": "Gradient",
    "modeArtwork": "Artwork",
    "backgroundColor": "Background color",
    "from": "From",
    "to": "To",
    "direction": "Direction",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "radial": "Radial",
    "artworkBackgroundCaption": "Album artwork will fill the poster background. Caption will remain on top.",
    "frostedOverlay": "Frosted overlay",
    "blurLevel": "Blur level",
    "layout": "Layout",
    "spacing": "Spacing",
    "layoutEdgeToEdge": "Edge to Edge",
    "fontGotham": "Gotham (built-in sans-serif)",
    "fontInter": "Inter (built-in sans-serif)",
    "fontSystem": "System default"
  },
  "export": {
    "title": "Export",
    "printPreset": "Print preset",
    "selectPreset": "Select print preset",
    "exportPng": "Export PNG",
    "exporting": "Exporting…",
    "presetLabel": "{label} · {width}×{height} px"
  },
  "presets": {
    "a4-portrait": "A4 Portrait",
    "a3-portrait": "A3 Portrait",
    "poster-12x18": "12×18 Poster",
    "poster-50x70cm": "50×70 cm Poster",
    "poster-40x60cm": "40×60 cm Poster",
    "poster-30x40cm": "30×40 cm Poster",
    "square": "Square Poster"
  },
  "preview": {
    "ariaLabel": "Album poster preview",
    "artworkAlt": "{title} artwork",
    "addArtwork": "Add artwork",
    "untitledAlbum": "Untitled Album",
    "releaseDate": "Release date",
    "unknownArtist": "Unknown Artist",
    "paletteAria": "Poster palette",
    "tracklistAria": "Tracklist"
  },
  "editionDialog": {
    "title": "Choose edition",
    "description": "This album has multiple MusicBrainz releases. Pick the edition whose tracklist and date should be used on the poster.",
    "unknownDate": "Unknown date",
    "tracks": "{count} tracks",
    "cancel": "Cancel"
  },
  "status": {
    "chooseEdition": "Choose an album edition to load its exact tracklist.",
    "selectionCancelled": "Album selection cancelled.",
    "albumLoaded": "Album data loaded. You can override every field.",
    "chooseModel": "Choose a poster model, then edit any details manually.",
    "modelApplied": "Poster model applied. Fine-tune the details or export when ready.",
    "notReady": "Poster preview is not ready to export.",
    "preparing": "Preparing PNG export…",
    "exported": "Exported {preset} PNG.",
    "exportFailed": "PNG export failed. Try another preset.",
    "artworkLookupFailed": "Artwork lookup failed. Add artwork manually.",
    "searchFailed": "MusicBrainz search failed."
  },
  "aria": {
    "toggleTheme": "Switch to {mode} mode",
    "light": "light",
    "dark": "dark"
  },
  "language": {
    "label": "Language",
    "en": "English",
    "tr": "Türkçe"
  }
}
